import React from 'react';
import styled from 'styled-components';

const StyledTextSegment = styled.text`{
    resize: none;
    display: flex;
    flex-direction: row; 
    align-items: center;
    justify-items: center;
    background-color: #EFF0F0; 
    border-radius: 10px; 
    overflow: hidden;
    width: 100%;
    padding-bottom: 18px;
    border-color: transparent;
    min-height: 60px;
    overflow-y: auto;
    word-wrap:break-word
  }`
  
  const HiddenTextSegment = styled.text`{
    resize: none;
    display: none;
    flex-direction: row; 
    align-items: center;
    justify-items: center;
    background-color: #EFF0F0; 
    border-radius: 10px; 
    overflow: hidden;
    width: 100%;
    border-color: transparent;
    min-height: 60px;
    overflow-y: auto;
    word-wrap:break-word
  }`
  
  const StyledBullets = styled.text`{
    display: flex;
    flex-direction: column;
    resize: none;
    overflow: hidden;
    width: 100%;
    padding-bottom: 18px; 
    border-color: transparent;
    min-height: 60px;
    overflow-y: auto;
    word-wrap:break-word
  }`
  
  const StyledTextArea = styled.div` {
    resize: none;
    display: flex;
    flex-direction: column; 
    // align-items: center;
    // justify-content: center;
    background-color: #EFF0F0; 
    border-radius: 10px; 
    overflow: hidden;
    width: 100%;
    margin: 24px auto 0px auto;
    margin-bottom: 128px;
    div.textArea{
        margin: 28px 40px 22px 40px; 
    }
  }`
  
  const StyledButton = styled.button` {
    background-color: #377879;
    color: white;
    font-weight: bold;
    border-radius: 0px 0px 10px 10px;
    padding: 16px; 
  }`

class DaysTimeline extends React.Component {
    render() {
        return (
        <div>
            <StyledTextArea id = "overview">
                <div className="textArea">
                <h2 className= 'my-3'>Overview of Stem Cell Transplantation</h2>
                <StyledTextSegment>Stem Cell Transplantation is a procedure in which healthy stem cells are transferred to a patient to replace damaged stem cells. Stem cells are produced in the soft tissue inside the bone called bone marrow. Stem cells are immature cells that grow into red blood cells, white blood cells, and platelets. The produce billions of new cells and platelets everyday. When the cell and platellets mature, they leave the bone marrow and enter the bloodstream</StyledTextSegment>
                <StyledTextSegment>Healthy bone marrow and stem cells are needed to live. if the stem cells cannot make enough new blood cells, serious health problems occur.</StyledTextSegment>
                <StyledTextSegment><b>A stem cell transplant is not surgery. It is more like a blood transfusion.</b></StyledTextSegment>
                
                <HiddenTextSegment id = "OverviewSpan">
                <StyledTextSegment>There are three types of Stem Cell Transplantation:</StyledTextSegment>
                <StyledBullets>Autologous transplantation: The procedure in which the patient’s own stem cells are used. The cells are collected from the patient’s bloodstream or marrow and safely stored until they are used for transplantation.</StyledBullets>
                <StyledBullets>Allogenic transplantation: The procedure in which stem cells donated by someone else (a donor) is used. The donor can be a family member or someone unrelated to the patient.</StyledBullets>
                <StyledBullets>Syngenic Transplantation: The procedure in which stems cells donated by the patient’s healthy identical twin is used.\n\nAllogenic and Syngenic Transplantation begin with chemotheraphy with or without radiation to kill the damaged cells in the patient’s body. Then, the healthy stem cells are introduced in the bloodstream through an Intravenous (IV) catheter (a small flexible tube that is introduced into the periphal vein). From this point, the stem cells travel and find their way into the patient’s marrow.</StyledBullets>
                </HiddenTextSegment>   
                </div>
                <StyledButton id = "overviewButton" href="javascript:void(0)" onClick= {() => expandText(document.getElementById('OverviewSpan'), document.getElementById('overviewButton'))}>Read More</StyledButton>
            </StyledTextArea>

            <StyledTextArea id = "hospitalStay">
                <div className="textArea">
                    <h2 className= 'my-3'>Hospital Stay</h2>
                    <StyledTextSegment>The recovery stage begins after the stem cell infusion. During this time, you and your family wait for the cells to engraft*, or “take,” after which they start to multiply and make new blood cells. The time it takes to start seeing a steady return to normal blood counts varies depending on the patient and the transplant type. However, it's usually about 2 to 6 weeks. You’ll be in the hospital or visit the transplant center daily for at least a few weeks.</StyledTextSegment>
                    <StyledTextSegment>Except for graft-versus-host disease*, which only happens with allogeneic transplants, the side effects from autologous, allogeneic, and syngeneic stem cell transplants are quite similar. Side effects may include stomach, heart, lung, liver, or kidney problems. (Stem Cell Transplant Side Effects goes into the details). Additionally, you might also go through feelings of distress, anxiety, depression, joy, or anger.</StyledTextSegment>
                    <StyledTextSegment><b>The engraftment period and recovery period for each patient is different.</b></StyledTextSegment>
                    
                    <HiddenTextSegment id = "hospitalStaySpan">
                    <StyledTextSegment>Adjusting emotionally after the transplant can be difficult because of the lengthy period of illness and isolation from others. You might feel as if you are on an emotional roller coaster during this time. Support and encouragement from family, friends, and the transplant team are very important to get you through the challenges after transplant. Also, during your stay, it is advisable to bring some entertainment, such as books, games, or movies, to keep you company.</StyledTextSegment>
                    <StyledTextSegment><i>* Engraftment is when the donated cells travel through the patient’s bloodstream to the bone marrow. Once in the bone marrow, the cells will start producing red blood cells, white blood cells, and platelets.</i></StyledTextSegment>
                    <StyledTextSegment><i>* Graft-versus-host disease (GVHD) is a common complication of allogenic transplants. GVHD is caused by disparities between a patient’s own cells and the donor’s cells. This usually happens because the patient’s new immune system (from the donor) might perceive the patient’s own cells as a threat and attack them.</i></StyledTextSegment>
                    </HiddenTextSegment>
                </div>
                <StyledButton id = "HospitalStayButton" href="javascript:void(0)" onClick= {() => expandText(document.getElementById('hospitalStaySpan'), document.getElementById('HospitalStayButton'))}>Read More</StyledButton>
            </StyledTextArea>

            <StyledTextArea id = "day0">
                <div className="textArea">
                    <h2 className= 'my-3'>Day 0</h2>
                    <StyledTextSegment><b>The day of transplant is often called “Day Zero.”</b></StyledTextSegment>
                    <StyledTextSegment>This is the day that you will receive your new cells. It is usually 1 or 2 days after you finish your preparative regimen*, however, the number of days vary based on a patient’s regimen.</StyledTextSegment>
                    <StyledTextSegment>When day zero arrives, it is normal to have many emotions. You may feel nervous about how your recovery will go. At the same time, you may feel excited about the arrival of your new cells.</StyledTextSegment>
                    
                    <HiddenTextSegment id = "day0Span">
                    
                    <StyledTextSegment>You will be in your hospital room and awake during the transplant. The stem cell transplant process is like a blood transfusion process. Your transplant team will watch you closely while you get your new cells. They’ll also explain what to expect, how long it might take and how you might feel.</StyledTextSegment>
                    <StyledTextSegment><i>* Preparative regimen is the process of preparing a patient’s body to receive the new donated cells.</i></StyledTextSegment>
                    </HiddenTextSegment>
                </div>
                <StyledButton id = "day0Button" href="javascript:void(0)" onClick= {() => expandText(document.getElementById('day0Span'), document.getElementById('day0Button'))}>Read More</StyledButton>
            </StyledTextArea>

            <StyledTextArea id = "day30">
                <div className="textArea">
                    <h2 className= 'my-3'>Day 30</h2>
                    <StyledTextSegment><b>After <em>engraftment*</em>, the initial recovery period typically lasts about 3 months after an <em>allogeneic transplant*</em> and about 1 month after an <em>autologous transplant*</em>. </b></StyledTextSegment>
                    <StyledTextSegment>You will remain in the hospital for part of the recovery stage and then will continue to recover as an outpatient.</StyledTextSegment>
                    <StyledTextSegment>You will be scheduled for clinic visits at least once a week as well as for regular blood draws and other tests. These visits and tests may be reduced closer to the end of your recovery period. Don't hesitate to contact your caregivers or doctors if you have any questions.</StyledTextSegment>
                    
                    
                    <HiddenTextSegment id = "day30Span">
                    <StyledTextSegment>Towards the end of your recovery period, you should feel better. Your appetite will return and you’ll be encouraged to shift from “just eat anything that you can stomach” to a high-protein and high-electrolyte diet. Also, your energy level will gradually increase.</StyledTextSegment>
                    <StyledTextSegment><i>* Autologous transplantation is the procedure in which the patient’s own stem cells are used. The cells are collected from the patient’s bloodstream or marrow and carefully stored until they are used for transplantation.</i></StyledTextSegment>
                    <StyledTextSegment><i>* Allogenic transplantation is the procedure in which stem cells donated by someone else (a donor) is used. The donor can be a family member or someone unrelated to the patient.</i></StyledTextSegment>
                    <StyledTextSegment><i>* Engraftment is when the donated cells travel through the patient’s bloodstream to the bone marrow. Once in the bone marrow, the cells will start producing red blood cells, white blood cells, and platelets.</i></StyledTextSegment>
                    </HiddenTextSegment>
                </div>
                <StyledButton id = "day30Button" href="javascript:void(0)" onClick= {() => expandText(document.getElementById('day30Span'), document.getElementById('day30Button'))}>Read More</StyledButton>
            </StyledTextArea>

            <StyledTextArea id = "day100">
                <div className="textArea">
                    <h2 className= 'my-3'>Day 100</h2>
                    <StyledTextSegment>Day 100 is a milestone that many stem cell transplant recipients circle boldly on their calendars as the turning point in their recovery. At this stage, the greatest risk for critical side effects is past and the stem cells have engrafted and begun making new blood cells.</StyledTextSegment>
                    <StyledTextSegment>There is a likelyhood of the occurence of Graft-versus-host disease (GVHD)* during this time. There’s a chance that GVHD will develop when the new stem cells start to engraft. A close match of Human Leukocyte Antigens (HLA)* or tissue type between you and your donor helps lower this risk but doesn’t make it go away.</StyledTextSegment>
                    <HiddenTextSegment id = "day100Span">
                        <StyledTextSegment>The symptoms of GVHD may be mild to severe. You may develop only acute GVHD*, only chronic GVHD*, or both acute and chronic GVHD. If you develop both, you may or may not have symptoms between the time that you develop acute and chronic GVHD.</StyledTextSegment>
                        <StyledTextSegment><i>* Graft-versus-host disease (GVHD) is a common complication of allogenic transplants. GVHD is caused by disparities between a patient’s own cells and the donor’s cells. This usually happens because the patient’s new immune system (from the donor) might perceive the patient’s own cells as a threat and attack them.</i></StyledTextSegment>
                        <StyledTextSegment><i>* Human Leukocyte Antigens (HLA) are molecules found in the surface of most cells in the body. They make up a person’s tissue type.</i></StyledTextSegment>
                        <StyledTextSegment><i>* Acute Graft-versus-host disease (GVHD) usually affects the patient’s skin, liver, stomach, and intentines.</i></StyledTextSegment>
                        <StyledTextSegment><i>* Chronic Graft-versus-host disease (GVHD) usually affects the patient’s skin, joints, nails, eyes, mouth, muscles, and other organs.</i></StyledTextSegment>
                    </HiddenTextSegment>
                </div>
                <StyledButton id = "day100Button" href="javascript:void(0)" onClick= {() => expandText(document.getElementById('day100Span'), document.getElementById('day100Button'))}>Read More</StyledButton>
            </StyledTextArea>
        </div>
        )
    }
}

  function expandText(stage, button) {
    
    if (stage.style.display != "none") {
      stage.style.display = "block";
    }
    if (button.style.display != "none") {
      button.style.display = "none";
    }
    
  }

  export default class Timeline100Days extends React.Component {
    render() {
      return (
          <DaysTimeline></DaysTimeline>
      );
    }
  }